import { AuthenticationError } from './AuthenticationError';

const API_BASE_URL = window.APP_CONFIG?.apiUrl || window.location.origin;

export interface AgencyEmail {
  id: number;
  email: string;
  createdAt: string;
  createdBy: string;
}

async function handleApiResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    if (response.status === 401) {
      throw new AuthenticationError('Your session has expired. Please log in again.');
    }
    const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(errorData.error || `API Error: ${response.status}`);
  }
  return response.json();
}

export const agencyApi = {
  async getEmails(): Promise<{ emails: AgencyEmail[] }> {
    const response = await fetch(`${API_BASE_URL}/api/reporters/me/agency/emails`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'include',
    });
    const result = await handleApiResponse<{ success: boolean; data: AgencyEmail[] }>(response);
    return { emails: result.data ?? [] };
  },

  async addEmail(email: string): Promise<{ success: boolean; warning?: string }> {
    const response = await fetch(`${API_BASE_URL}/api/reporters/me/agency/emails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email }),
    });
    return handleApiResponse(response);
  },

  async removeEmail(email: string): Promise<{ success: boolean }> {
    const response = await fetch(`${API_BASE_URL}/api/reporters/me/agency/emails/${encodeURIComponent(email)}`, {
      method: 'DELETE',
      headers: { 'Accept': 'application/json' },
      credentials: 'include',
    });
    return handleApiResponse(response);
  },
};
